var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import DataTable from '@/components/data-table/DataTable';
import { GlobalUser } from '@/models/GlobalUser';
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import RolesAutocomplete from '@/components/Autocompletes/RolesAutocomplete/RolesAutocomplete';
import CreateDialog from '@/views/Admin/Users/CreateDialog/CreateDialog';
import Roles, { RolesEnum } from '@/items/Roles';
import ErrorHandler from '@/support/ErrorHandler';
let Users = class Users extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Users';
        this.isCreating = false;
        this.filters = {};
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get canCreateUser() {
        return (this.$store.state.Auth && this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT]));
    }
    get items() {
        const acceptedValues = [
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ];
        return Roles.items.filter((item) => acceptedValues.includes(item.id));
    }
    get user() {
        return this.$store.state.Auth;
    }
    get tableFilters() {
        return this.filters;
    }
    get tableVisibility() {
        return {
            total: false,
        };
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('group.title', 1),
                plural: this.$tc('group.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    action: '/admin/users/{id}',
                },
                {
                    text: 'Role',
                    value: 'roles',
                    transform: (role, user) => {
                        if (role.length) {
                            return Roles.texts[role[0].id];
                        }
                        return '-';
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/admin/users/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, user) => {
                        this.$store.dispatch('openDialog', this.dialogOptions(user));
                    },
                    roles: [RolesEnum.ADMIN],
                },
            ],
            filters: [],
            model: new GlobalUser().filter(this.tableFilters),
        };
    }
    dialogOptions(user) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, {
                item: this.$t('dialogOptions.item.group'),
            }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        user
                            .delete()
                            .then((response) => {
                            this.refreshDataTable();
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        //
                    },
                },
            },
        };
    }
};
Users = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            RolesAutocomplete,
            CreateDialog,
        },
    })
], Users);
export default Users;
